module.exports = {
          srcSet: __webpack_public_path__ + "public/images/36323ac3413f35e6dbae1f62bf80acf2-1920.jpg"+" 1920w",
          images:[ {path: __webpack_public_path__ + "public/images/36323ac3413f35e6dbae1f62bf80acf2-1920.jpg",width: 1920,height: 881}],
          src: __webpack_public_path__ + "public/images/36323ac3413f35e6dbae1f62bf80acf2-1920.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/36323ac3413f35e6dbae1f62bf80acf2-1920.jpg"},
          
          width: 1920,
          height: 881
        }